import * as React from "react";
import { IconProps } from "../types";

const LaptopOutlineIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
      >
        <path
          d="M4.25 12.25C3.145 12.25 2.25 11.355 2.25 10.25V4.75C2.25 3.645 3.145 2.75 4.25 2.75H13.75C14.855 2.75 15.75 3.645 15.75 4.75V10.25C15.75 11.355 14.855 12.25 13.75 12.25"
          stroke={color}
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M17.25 12.25H0.75C0.75 13.9069 2.0931 15.25 3.75 15.25H14.25C15.9069 15.25 17.25 13.9069 17.25 12.25Z"
          stroke={color}
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    );
  },
);

export default LaptopOutlineIcon;
